import { Fragment } from 'react'

import {
  BLOG_HERO_DESKTOP_H1_FONT,
  BLOG_HERO_TITLE,
  BLOG_INTRO_DESKTOP_LEAD,
  BLOG_INTRO_DESKTOP_TAIL,
  BLOG_INTRO_MOBILE_FLUID,
  BLOG_INTRO_MOBILE_LINES,
} from '@/features/blog/constants/blog.constants'
import { cn } from '@/shared/lib/utils'

export function BlogPageHeader() {
  return (
    <header className="w-full text-left md:max-w-3xl">
      <h1
        className={cn(
          'font-bold not-italic text-[#242424]',
          'max-md:relative max-md:-top-[0.82px] max-md:w-full max-md:max-w-full max-md:whitespace-nowrap max-md:text-[clamp(22px,8.6vw,36px)] max-md:leading-[1.1] max-md:tracking-[-0.9px] max-md:[font-family:var(--font-blog-lora),serif]',
          'md:relative md:-top-[0.2px] md:max-w-[381px] md:whitespace-nowrap md:text-[48px] md:leading-[48px] md:tracking-[-1.2px]',
          BLOG_HERO_DESKTOP_H1_FONT,
        )}
      >
        {BLOG_HERO_TITLE}
      </h1>
      <p
        className={cn(
          'mt-3 w-full text-base leading-relaxed text-neutral-600 max-md:max-w-none [text-wrap:pretty] md:max-w-none',
        )}
      >
        <span className="md:hidden">
          <span className="sm:hidden">
            {BLOG_INTRO_MOBILE_LINES.map((line, i) => (
              <Fragment key={i}>
                {line}
                {i < BLOG_INTRO_MOBILE_LINES.length - 1 ? <br /> : null}
              </Fragment>
            ))}
          </span>
          <span className="hidden sm:block">{BLOG_INTRO_MOBILE_FLUID}</span>
        </span>
        <span className="hidden md:inline-block md:whitespace-nowrap">{BLOG_INTRO_DESKTOP_LEAD}</span>
        <span className="hidden md:block">{BLOG_INTRO_DESKTOP_TAIL}</span>
      </p>
    </header>
  )
}
